module.exports = __webpack_public_path__ + "static/media/lilyana.e1915b3f.jpg";